import { Route } from '@angular/router';
import { PAGE_TITLE_SUFFIX } from '../../../app.constants';

import { UserRouteAccessService } from '../../../shared';
import { PasswordResetInitComponent } from './password-reset-init.component';

export const passwordResetInitRoute: Route = {
  path: 'reset/request',
  component: PasswordResetInitComponent,
  data: {
    needAuthentication: false,
    pageTitle: `Réinitialisation du mot de passe${PAGE_TITLE_SUFFIX}`
  },
  canActivate: [UserRouteAccessService]
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/init/password-reset-init.route.ts